import React from 'react';

const ReportIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5 0C12.6716 0 12 0.671573 12 1.5V14.5C12 15.3284 12.6716 16 13.5 16H14.5C15.3284 16 16 15.3284 16 14.5V1.5C16 0.671573 15.3284 0 14.5 0H13.5Z"
      fill="currentColor"
    />
    <path
      d="M7.5 4C6.67157 4 6 4.67157 6 5.5V14.5C6 15.3284 6.67157 16 7.5 16H8.5C9.32843 16 10 15.3284 10 14.5V5.5C10 4.67157 9.32843 4 8.5 4H7.5Z"
      fill="currentColor"
    />
    <path
      d="M1.5 8C0.671573 8 0 8.67157 0 9.5V14.5C0 15.3284 0.671573 16 1.5 16H2.5C3.32843 16 4 15.3284 4 14.5V9.5C4 8.67157 3.32843 8 2.5 8H1.5Z"
      fill="currentColor"
    />
  </svg>
);

export default ReportIcon; 